module.exports = __webpack_public_path__ + "SourceSans3-It.ttf.764bc.woff2";